import { Box, Card, Chip, Divider, Paper, Typography } from '@mui/material';
import React from 'react';
import ActionOnCommandIcon from '../../../svg-icons/ActionOnCommandIcon';
import OrderCancelIcon from '../../../svg-icons/OrderCancelIcon';
import RefundRecap from './RefundRecap.jsx';

const OrderCancelRecap = ({ cancel, currency }) => {
  if (!cancel) {
    return null;
  }

  const nameToDisplay =
    cancel?.author?.firstName + ' ' + cancel?.author?.lastName;

  return (
    <Paper
      elevation={16}
      key={cancel?._id}
      sx={{
        padding: 0,
        marginBottom: 1,
        boxShadow: 'none',
      }}
    >
      <Card
        elevation={5}
        sx={{
          display: 'flex',
          gap: 2,
          padding: 1,
          alignItems: 'center',
          justifyContent: 'space-evenly',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <ActionOnCommandIcon fontSize="large" />
            <Typography component={'span'} sx={{ fontSize: '0.9em' }}>
              {nameToDisplay}
            </Typography>
            <Typography component={'span'} sx={{ fontSize: '0.9em' }}>
              {`Annulation (${cancel?.reason?.name})`}
            </Typography>
            <Typography component={'span'} variant="caption">
              {new Date(cancel?.updatedAt).toLocaleString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
              })}
            </Typography>
          </Box>
          <Divider />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <OrderCancelIcon fontSize="medium" />
            <Chip
              label={`Annulation de commande ${cancel?.status?.name?.name}`}
              color={
                cancel?.status?.name?.code === 'CREATED'
                  ? 'success'
                  : cancel?.status?.name?.code === 'ERRORED'
                    ? 'error'
                    : 'warning'
              }
              variant="outlined"
              size="small"
              sx={{ width: 'fit-content', borderRadius: '5px' }}
            />
          </Box>
          Référence d&apos;annulation
          <Typography
            sx={{
              color: 'primary.main',
              fontWeight: 'bold',
            }}
          >
            {cancel?.reference}
          </Typography>
        </Box>
        {cancel?.refund && (
          <Box sx={{ width: '100%' }}>
            <Divider>Remboursement</Divider>
            <Box sx={{ width: '95%', ml: '5%' }}>
              <RefundRecap
                refund={{
                  ...cancel?.refund,
                  refundType: { name: 'Annulation' },
                  orderRef: cancel?.order?.reference,
                }}
                currency={currency}
              />
            </Box>
          </Box>
        )}
      </Card>
    </Paper>
  );
};

export default OrderCancelRecap;
